import {
    ChangeDetectionStrategy,
    Component,
    computed,
    forwardRef,
    inject,
    Injector,
    input,
    signal,
    Signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop'; // WICHTIG
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { CustomControl } from '../custom-control/custom-control.component';

@Component({
    selector: 'tran-textarea-field',
    imports: [ReactiveFormsModule, TranslateModule, SiFormItemComponent],
    templateUrl: './textarea-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextareaFieldComponent), multi: true }]
})
export class TextareaFieldComponent extends CustomControl<string> {
    private readonly translate = inject(TranslateService);
    private readonly injector = inject(Injector);

    private _value: Signal<string | null | undefined> = signal(undefined);

    public readonly label = input.required<string>();
    public readonly placeholder = input<string>('application-form.add-comment');
    public readonly textareaHeightClass = input<string>('h-24');
    public readonly textareaClass = input<string>('');
    public readonly errorMapper = input<Record<string, string>>({});
    public readonly readonly = input(false);

    protected readonly textareaClasses = computed(() =>
        `form-control resize-y ${this.textareaHeightClass()} ${this.textareaClass()}`.trim()
    );

    protected readonly finalErrorMapper = computed(() => {
        this._value();

        const mapper = { ...this.errorMapper() };
        const errors = this.control.errors;

        if (errors?.['maxlength']) {
            const max = errors['maxlength'].requiredLength;
            mapper['maxlength'] = this.translate.instant('application-form.max-chars', { max });
        }

        return mapper;
    });

    public override ngOnInit(): void {
        super.ngOnInit();
        this._value = toSignal(this.control.valueChanges, { injector: this.injector });
    }
}
